import React from 'react';
import { motion } from 'framer-motion';
import { FileText, CheckSquare, Download } from 'lucide-react';
export function WhatYouGet() {
  return <section className="py-12 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-270">
      <div className="max-w-7xl mx-auto" data-id="element-271">
        <div className="text-center mb-8 lg:mb-16" data-id="element-272">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-charcoal mb-4 lg:mb-6" data-id="element-273">
            Lo que recibes exactamente
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-274">
          {/* Left: Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="lg:col-span-5 relative" data-id="element-275">
            <div className="absolute inset-0 bg-china-red/5 rounded-3xl transform rotate-3" data-id="element-276"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9QuuEXy93YYfnSKxMACxPp/heylloyd-image-1770828278530.png" alt="China Sin Estrés en Tablet" className="relative rounded-2xl shadow-2xl w-full h-auto object-cover" data-id="element-277" />
          </motion.div>

          {/* Right: Content */}
          <div className="lg:col-span-7 space-y-6 lg:space-y-10" data-id="element-278">
            {/* PDF Section */}
            <div data-id="element-279">
              <div className="flex items-center mb-4 lg:mb-6" data-id="element-280">
                <div className="p-2 lg:p-3 bg-china-red/10 rounded-lg mr-3 lg:mr-4" data-id="element-281">
                  <FileText className="h-5 w-5 lg:h-6 lg:w-6 text-china-red" data-id="element-282" />
                </div>
                <h3 className="text-xl lg:text-2xl font-bold text-charcoal font-serif" data-id="element-283">
                  PDF principal (China Sin Estrés 2026)
                </h3>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 ml-0 sm:ml-16" data-id="element-284">
                {['Checklist 7 días antes (Kit Anti‑Bloqueo)', 'Protocolo de aterrizaje (primera hora)', 'Pagos: sistema en 3 capas', 'Conectividad: opciones + Plan B', 'Navegación: favoritos críticos', 'Transporte: tren/metro/taxi sin errores', 'Módulos por ciudad (con ritmo real)', 'Itinerarios listos: 7 / 10 / 14 / 21 días'].map((item, i) => <div key={i} className="flex items-start" data-id="element-285">
                    <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 mr-2 flex-shrink-0" data-id="element-286"></div>
                    <span className="text-charcoal-light text-sm sm:text-base" data-id="element-287">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="w-full h-px bg-gray-100" data-id="element-288"></div>

            {/* Checklists Section */}
            <div data-id="element-289">
              <div className="flex items-center mb-4 lg:mb-6" data-id="element-290">
                <div className="p-2 lg:p-3 bg-gold/10 rounded-lg mr-3 lg:mr-4" data-id="element-291">
                  <CheckSquare className="h-5 w-5 lg:h-6 lg:w-6 text-gold" data-id="element-292" />
                </div>
                <h3 className="text-xl lg:text-2xl font-bold text-charcoal font-serif" data-id="element-293">
                  Checklists imprimibles + plantillas
                </h3>
              </div>

              <div className="space-y-3 ml-0 sm:ml-16" data-id="element-294">
                {['“Mi plan de mañana” (10 minutos)', 'Checklist noche antes de cambiar de ciudad', 'Frases clave listas para traducir'].map((item, i) => <div key={i} className="flex items-center bg-off-white p-3 rounded-lg border border-gray-100" data-id="element-295">
                    <Download className="h-4 w-4 text-gray-400 mr-3" data-id="element-296" />
                    <span className="text-charcoal font-medium" data-id="element-297">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}